export default "__VITE_ASSET__0WEbuOYv__"